export enum UserRoleEnum {
  Dictionary = 'DICTIONARY',
  Employee = 'EMPLOYEE',
  InstitutionAdmin = 'INSTITUTION_ADMIN',
  Acceptance = 'ACCEPTANCE',
  InternalAdmin = 'INTERNAL_ADMIN',
  InstitutionWorker = 'INSTITUTION_WORKER',
  Archive = 'ARCHIVE',
  //TODO Dlete after implement nmvp. Technical role for hide elements that no available on MVP
  NoMVP = 'no_MVP',
}
